/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import DefaultFilterBoxExample from '../examples/DefaultFilterBox';
import OpenFilterBoxExample from '../examples/OpenFilterBox';
import FilterBoxSelectingParametersExample from '../examples/FilterBoxSelectingParameters';
import FilterBoxWithSelectedParametersExample from '../examples/FilterBoxWithSelectedParameters';
const DefaultFilterBoxExampleSource = require('!!raw-loader!../examples/DefaultFilterBox');
const OpenFilterBoxExampleSource = require('!!raw-loader!../examples/OpenFilterBox');
const FilterBoxSelectingParametersExampleSource = require('!!raw-loader!../examples/FilterBoxSelectingParameters');
const FilterBoxWithSelectedParametersExampleSource = require('!!raw-loader!../examples/FilterBoxWithSelectedParameters');
export default class FilterBoxPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="FilterBox"/>
                <h3>Default filter box</h3>
                <div className="docs-example">
                    <DefaultFilterBoxExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{DefaultFilterBoxExampleSource}</PrismCode>
                </pre>

                <h3>Open filter box</h3>
                <div className="docs-example">
                    <OpenFilterBoxExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{OpenFilterBoxExampleSource}</PrismCode>
                </pre>

                <h3>Filter box - selecting parameters</h3>
                <div className="docs-example">
                    <FilterBoxSelectingParametersExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{FilterBoxSelectingParametersExampleSource}</PrismCode>
                </pre>

                <h3>Filter box with selected parameters</h3>
                <div className="docs-example">
                    <FilterBoxWithSelectedParametersExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{FilterBoxWithSelectedParametersExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
